import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'Hovsa! Noget gik galt...',
  subheader:
    'Siden, du leder efter, er desværre ikke lige i øjet. Vi beklager og kan ikke vise den nu.',
  buttonText: 'Gå til forsiden',
}
